import { Component, OnInit }   from '@angular/core';
import { Router }              from '@angular/router';

@Component ({
    selector:     'mt-wizard-personal'
    ,templateUrl: './personal.component.html',
    styleUrls: ['./personal.component.css']
})

export class PersonalComponent implements OnInit {
    title = 'Please tell us about yourself.';
    form: any;
    
    constructor(private router: Router) {
    }

    ngOnInit() {
        // this.personal = this.formDataService.getPersonal();
    }

    // save(form: any): boolean {
    //     if (!form.valid) {
    //         return false;
    //     }
            
    //     // this.formDataService.setPersonal(this.personal);
    //     return true;
    // }

    // goToNext(form: any) {
    //     if (this.save(form)) {
    //         // Navigate to the work page
    //         this.router.navigate(['/work']);
    //     }
    // }

    // goToPrevious(form: any) {
    //               this.router.navigate(['/applicant/info/upload-image']);
    // }
}
